import { Container } from '@mui/material';
import HeaderBreadcrumbs from '../../../components/HeaderBreadcrumbs';
import Page from '../../../components/Page';
import { useParams } from 'react-router-dom';
import ToppingsCategoryItemForm from './ToppingsCategoryItemForm';

const index = () => {
  const params: any = useParams();
  const isAddMode = !params?.id;
  return (
    <Page title={'Toppings Category Item'}>
      <Container maxWidth={'xl'}>
        <HeaderBreadcrumbs
          heading={`${isAddMode ? 'Add Toppings Category Item' : 'Edit Toppings Category Item'} `}
          links={[
            { name: 'Dashboard', href: '/' },
            { name: 'Toppings Category Item', href: '/toppings-category-item' },
          ]}
        />
        <ToppingsCategoryItemForm />
      </Container>
    </Page>
  );
};

export default index;
